import * as constant from "../Constants";
import { BaseService } from "../Base";

export class Service extends BaseService {
  constructor(id) {
    super();
    this.configuration = {
      ...this.configuration,
      method: constant.BASE.method.patch,
      resource: constant.BASE.resource.partners,
      pathParameter: id
    };
    this.query = null;
  }
}
